const environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = Object.assign({
  CONN_STATUS_CHANGE:'701',
  ERROR_MSG:'1',
  ACC_BAL_UPDATE:'601',
  MSG_TO_TRD:'2',
  UPDATE_STOCK:'709',
  UPDATE_CUST_MARGIN:'708',
  TRD_MASTER_CNG:'702',
  KILL_TRD_SES:'11',
  FORCED_LOGOUT:'12',
  ACC_MT_CHANGE_LOGOUT:'703',
  INITIAL_CHECKS_FAILED:'106',
  SUB_COMP_STATUS_INACTIVE:610,
  MARGIN_CHECKS_FAILED:'107',
  NEWS_FEED:'5',
  END_OF_DAY:'609',
  FAILED :100,
  EXCEEDS_EXPOSURE :101,
  INSUFFICIENT_MRG :102,
  EXCEEDS_TRDLIMIT :103,
  EXCEEDS_ORDLIMIT :104,
  TRD_PROCESS_ISSUE :105,
  NO_DEALER :106,
  TRD_DISABLED :107,
  TRD_ROUTE_ISSUE :108,
  SESSION_EXP :109,
  TRD_PLACE_FAIL :110,
  // REQ_CONF_MRG :111,
  REQ_CONF_TRD :112,
  MRK_ORD_CACNEL:602,
  ORD_NOT_OST :113,
  WAIT_FOR_CANC_CONF :114,
  ORD_PROCEED :115,
  INVALID_DATE :116,
  REJ_ACCLOCKED :117,
  QTY_GREATER_THAN_MAX_HEDGE_QTY :118,
  QTY_LESS_THAN_MIN_HEDGE_QTY:123,
  HEDGE_REJECT :119,
  FUNDS_REVAL_ZERO :120,
  WORST_NOP_BREACH :121,
  BM_NOT_VALID :122,
  SUCCESS :200,
  INPROCESS :205,
  MRG_FAILED :300,
  MRG_SUCCESS :400,
  PRC_MOVED :500,
  DEAL_FAIL_STALE_PRC :600,
  ORD_FILLED :601,
  TRADE_REQUEST_RECEIVED:'102',
  TRADE_REQUEST_REJCTED:'104',
  ORDER_REQUEST_REJECT :'210',
  REQUEST_REJECT:'202',
  TRADE_REQUEST_CONFIRMED:'103',
  TRADER_BUY:1,
  ORD_REQ_RECD:'201',
  ORD_PLACED:'206',
  MODIFY_REQ_RECD:'204',
  ORD_MODIFY_REJECT:'203',
  ORD_MODIFIED:'207',
  ORD_CANCEL:'208',
  SYNTHETIC_ORDER_CANCELLED: '220',//Hedge order cancelled by provider(only for dealer)
  ORD_CANCEL_REQUEST:'205',
  ORD_UNHEDGE_FILL:'219',
  ORDER_EXPIRED:'212',
  HEGDGE_SETT_CHNG:'704',
  ORDER_UNHEDGE_EXPIRED:'226',
  ORD_HEDGE_FILL:'209',
  UPDATE_VALUE_DATE:'711',
  FIXING_ORDER_CUTOFF:'309',
  UPDATE_BMDETAILS:'705',
  ACC_CHANGE:'714',
  OPEN_TRADE:'715',
  NEWORD:1,
  MODORD:2,
  CANCELORD:6,
  GTD:6,
  GTC:1,
  DAY:0,
  GTT:60,
  TRD_LOGIN:'7',
  TRD_LOGOUT:'8',
  DEAL_CONFM:'13',
  NO_PRICE:207,
  TRADE_PANEL_COUNT:10,
  ORD_PARTIAL_FILL:'109',
  ORDER_PARTIAL_FILL_CAN_EXP:'230',
  ONLY_MRKUP_MODIFIED:'232',
  UPDATE_SHOWPRICE:'717',
  UPDATE_STKCODE_MARKUP:'716',
  BROKER_ORDER_MANUAL_CANCEL : "413",
  TRADING_DISABLE:'101',
  PREV_ORDER_REQUEST_INPROGRESS:129,
  PHYSICAL_DELIVERY_REQUEST_RECEIVED:'240',
  PHYSICAL_DELIVERY_REQUEST_PLACED:'241',
  PHYSICAL_DELIVERY_REQUEST_CANCELLED:'245',
  PHYSICAL_DELIVERY_DELIVERED:'246',
  PHYSICAL_DELIVERY_MARGIN_CHECKS_FAIL: '248',
  FIXING_ORDER_REQ_RECD:'301',//"BENCHMARK_REQ_RECD";
  FIXING_ORDER_PLACED:'304',//"BENCHMARK_MOD_REQ_RECD";
  FIXING_ORDER_MOD_REQ_RECD:'302',//BENCHMARK_CANC_REQ_RECD";
  FIXING_ORDER_MODIFIED:'305', //"BM_PLACED";
  FIXING_ORDER_CANC_REQ_RECD:'303',//"BM_MODIFIED";
  FIXING_ORDER_CANCELLED:'306',//"BM_CANCELLED";
  FIXING_ORDER_MANUAL_FILL:'307',//"BENCHMARK_MANUAL_FILL";
  FIXING_REQUEST_REJCTED:"308", //"BENCHMARK_REQUEST_REJCTED";
  FIXING_CUTOFF :"309", //"BENCHMARK_CUTOFF";
  FIXING_ORDER_FILLED :"312",
  FIXING_ORDER_REJECTED : "318",
  FIXING_ORDER_MODIFY_OR_CANCEL_REJECTED:"320",
  INVALID_CHECK : "111",
  FX_NOT_VALID:130,//Benchmark not valid for the day.
  HOLIDAY:131, //fixing date is in holiday
  MKT_LMT_NOT_ALLOW: 139, //Market & Limit order date is in holiday
  WEEKNED:132, //The date falls on a holiday
  FX_OUTOF_DATE_RANGE:133, //Out of range
  FXDATE_BEFORE_DOCDATE:134, //The selected fixing date cannot be before Doc Date.
  FX_NOT_ALLOW:135, //Benchmark modifification/cancellation not allowed after trade day.
  OPEN_POSITION_CHECKS_FAILED:'112',//openPosition check failed
  NOT_ENOUGH_FUND_TO_BUY:124,//for BUY fail
  NOT_ENOUGH_STK_POSITION_TO_SELL:125,//for SELL fail,
  HB_ACK: "20",
  INVALID_OPEN_TRADE_REQUEST:'723',//  show popup alert message to user & call open trade book refresh API. 
  milliSecDateFormat:'YYYY/MM/DD HH:mm:ss.SSS',
  validityDateFormat:'YYYY-MM-DD HH:mm',
  shortDateFormat:'DD-MMM-YY',
  rptDateFormat:'DD-MMM-YY',
  actTimeDateTimeFormatter:'YYYY-MM-DD HH:mm:ss.SSS',
  dmyFmt:'YYYY-MM-dd',
  ddmmFmt :'MM-dd',
  lastloginDateFrmat:'YYYY-MM-DD HH:mm:ss.SSS',
  loginDateFrmat:'DD-MMM-YYYY HH:mm:ss',
  ymmdd: 'YYYY-MM-DD',
  valueDateFormat:'YYYY/MM/DD',
  LOCATION_MAPPING :[
    {
        "DESC": "SPM",
        "CODE": "SP"
    },
    {
        "DESC": "LHP",
        "CODE": "LH"
    },
    {
        "DESC": "YLG",
        "CODE": "YS"
    },
    {
        "DESC": "MAH",
        "CODE": "MH"
    },
    {
        "DESC": "ARH",
        "CODE": "AR"
    },
    {
        "DESC": "GJL",
        "CODE": "GJ"
    },
    {
        "DESC": "GJP",
        "CODE": "GP"
    },
    {
        "DESC": "DAE",
        "CODE": "DA"
    },
    {
        "DESC": "AGR",
        "CODE": "AG"
    },
    {
        "DESC": "ORO",
        "CODE": "GJ"
    },
    {
        "DESC": "AJF",
        "CODE": "AJ"
    },
    {
        "DESC": "AGS",
        "CODE": "AS"
    },
    {
        "DESC": "AGD",
        "CODE": "AD"
    },
    {
        "DESC": "ASK",
        "CODE": "G2"
    },
    {
        "DESC": "G3",
        "CODE": "G3"
    },
    {
        "DESC": "MRD",
        "CODE": "MC"
    },
    {
        "DESC": "SWD",
        "CODE": "SC"
    },
    {
        "DESC": "PRC",
        "CODE": "PC"
    },
    {
        "DESC": "LND",
        "CODE": "LC"
    },
    {
        "DESC": "BRL",
        "CODE": "BC"
    },
    {
        "DESC": "UG2",
        "CODE": "G2"
    },
    {
        "DESC": "UG3",
        "CODE": "G3"
    },
    {
        "DESC": "FAY",
        "CODE": "AF"
    },
    {
        "DESC": "PCG",
        "CODE": "PC"
    }
  ],
  trackingEvents : {
    PLACE_TRADE: 'Place trade',
    PLACE_ORDER: 'Place order',
    MODIFY_ORDER: 'Modify Order',
    CANCEL_ORDER: 'Cancel Order',
    MODIFY_SQUARE_OFF: 'Modify Square Off'
}

}, environment);
